// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._18m915vq{overflow-y:hidden}\n._1bto1l2s{text-overflow:ellipsis}\n._1e0c1o8l{display:inline-block}\n._1reo15vq{overflow-x:hidden}\n._kqswh2mm{position:relative}\n._o5721q9c{white-space:nowrap}\n._s7n4yfq0{vertical-align:bottom}", ""]);
// Exports
module.exports = exports;
